<script lang="ts">
    import {_} from '../services/i18n';
    import StepInfoItem from "./StepInfoItem.svelte";
    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher();

    export let sticky = false;

    import { getContext } from 'svelte';
    import {entityStore, myStore} from "../stores.js";
    import {Utils} from "../util";

  //  const { formData} = getContext('formData');

    //fake steps for testing:
   //let steps = $myStore.steps;
    function onSubmitBtnClicked(){
       dispatch('submitBtnClicked');
    }

    const debouncedLogIsValid = Utils.debounce(Utils.logMessageAndValue, 500);
    const debouncedLogErrors = Utils.debounce(Utils.logMessageAndValue, 500);

    /*
    // Debounced console log
    const debouncedLog = debounce((msg:String,value:any) => {
       console.log(msg + ": ", value);
    }, 500); // Adjust 500ms to your needs
   */


    $: {
       //steps = $myStore.steps;
       debouncedLogIsValid('isValid?',$myStore.isValid);
       debouncedLogErrors('errors',$myStore.errors);

       console.log("steps update XX  = ", $entityStore.steps);
    }


</script>
<!-- translation example: {$_('introText')}-->

<div class="left-sidebar placeholder-element" class:sticky={sticky}></div>
<div class="left-sidebar" class:fixed={sticky}>
   <div class="stepper-wrapper">
      {#each $entityStore.steps as {title, isActive, valid, touched}}
         <StepInfoItem {title} {isActive} {valid} {touched}/>
      {/each}
   </div>


   <button class="mt-2 btn btn-brand submitBtn" type="submit" on:click={onSubmitBtnClicked}>Envoyer</button>


</div>


<style lang="scss">

   .left-sidebar{
      max-width:300px; /*TODO media queries needed*/
   }

   .left-sidebar.placeholder-element{
      display:none;
      &.sticky{
         display:block;
      }
   }

   .left-sidebar.fixed{
      position:fixed;
      top:150px;
   }

   .stepper-wrapper{

      margin-top:20px;
      height: 450px;
   }

</style>
